



















import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, State, Getter } from "vuex-class";
import { ShopItemOptionDefinition } from "@/store/states/ShopState";
import { CartState } from "@/store/states/CartState";
import shopItemRawDefinitions from "@/assets/shop-items-definitions.json";

@Component
export default class MultipleChoiceOption extends Vue {
  @State("cart") cart: CartState;
  @Getter("quantity", { namespace: "cart" }) quantity: number;
  @Action("setOption", { namespace: "cart" }) setOption: Function;

  @Action("selectOptionFromMultipleChoice", { namespace: "cart" })
  select: Function;

  @Prop({ required: true })
  public currentOption!: ShopItemOptionDefinition;

  public selectedQuantity = shopItemRawDefinitions.quantities.min;

  mounted() {
    this.selectedQuantity = this.quantity;
    this.updateQuantity();
  }

  get minQuantity() {
    return shopItemRawDefinitions.quantities.min;
  }

  get maxQuantity() {
    return shopItemRawDefinitions.quantities.max;
  }

  public updateQuantity() {
    this.setOption({
      itemOptionUuid: this.currentOption.uuid,
      optionKey: "quantity",
      optionValue: this.selectedQuantity,
    });
  }
}
